export class ChangePasswordModel {
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
    token: string;
  }